import Vue from 'vue'
import VueRouter from 'vue-router'

// 只需要注册一次VueRouter
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/components/HomeView.vue'),
    },
    {
        path: '/aboutus',
        name: '集团介绍',
        component: () => import('@/components/aboutus/AboutPage.vue'),
        redirect: '/aboutus/aboutusView', // 新增：访问 /aboutus 时自动跳转到子路由
        children: [
            {
                path: 'aboutusView',
                name: '集团介绍详情',
                component: () => import('@/components/aboutus/aboutusView.vue'),
            },
            {
                path: 'BrandHistory',
                name: '品牌历程',
                component: () => import('@/components/aboutus/BrandHistory.vue'),
            },
            {
                path: 'CorporateCulture',
                name: '企业文化',
                component: () => import('@/components/aboutus/CorporateCulture.vue'),
            },
            {
                path: 'BrandAd',
                name: '品牌宣传',
                component: () => import('@/components/aboutus/BrandAd.vue')
            }
        ]
    },
    {
        path: '/ProductShowcase',
        name: '产品介绍',
        component: () => import('@/components/ProductShowcase.vue')
    },
    {
        path: '/NewsView',
        name: '新闻中心',
        component: () => import('@/components/NewsView.vue'),
    },
    {
        path: '/newsdetail',
        name: '新闻详情',
        component: () => import('@/components/newsdetail.vue'),
    },
    {
        path: '/waterSourceLocation',
        name: '水源地与产地',
        component: () => import('@/components/waterSourceLocation/WaterSourceLocation.vue'),
        children: [
            {
                path: 'SourceViewPage',
                name: '水源介绍',
                component: () => import('@/components/waterSourceLocation/SourceViewPage.vue'),
            },
            {
                path: 'PlantViewPage',
                name: '种植基地介绍',
                component: () => import('@/components/waterSourceLocation/PlantViewPage.vue'),
            },
            {
                path: 'FactoryViewPage',
                name: '工厂介绍',
                component: () => import('@/components/waterSourceLocation/FactoryViewPage.vue'),
            }
        ]
    },
    {
        path: '/ContactView',
        name: '联系我们',
        component: () => import('@/components/ContactView.vue'),
    },
    {
        path: '/controlView',
        name: '集团管控',
        component: () => import('@/components/ControlView.vue'),
    },
    {
        path: '/JobRecruitment',
        name: '人才招聘',
        component: () => import('@/components/JobRecruitment.vue'),
    },
    {
        path: '/socialResponsibility',
        name: '社会责任',
        component: () => import('@/components/socialResponsibility/SocialResponsibility.vue'),
        children: [
            {
                path: 'publicWelfareView',
                name: '公益帮扶助力',
                component: () => import('@/components/socialResponsibility/PublicWelfareView.vue'),
            },
            {
                path: 'agricultureView',
                name: '三农优选计划',
                component: () => import('@/components/socialResponsibility/AgricultureView.vue'),
            },
            {
                path: 'countryView',
                name: '乡村振兴战略',
                component: () => import('@/components/socialResponsibility/CountryView.vue'),
            },
            {
                path: 'healthyView',
                name: '健康中国品牌',
                component: () => import('@/components/socialResponsibility/HealthyView.vue'),
            }
        ]
    }
]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const element = document.querySelector(to.hash)
                    if (element) {
                        resolve({
                            selector: to.hash,
                            behavior: 'smooth'
                        })
                    }
                }, 100)
            })
        }
        else if (savedPosition) {
          return savedPosition;
        }
        else {
          return { x: 0, y: 0 };
        }
      }
})
router.afterEach(() => {
    window.scrollTo(0, 0)
})

export default router
